module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "channels"
  }, [_c('div', {
    staticClass: "channel",
    class: {
      selected: _vm.selectedTopic === 'all'
    },
    on: {
      "click": function($event) {
        return _vm.handleSelectTopic('all')
      }
    }
  }, [_c('div', {
    staticClass: "type"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "room",
    class: {
      unread: _vm.allUnread > 0
    }
  }, [_vm._v("all")])]), _vm._v(" "), _vm._l((_vm.tags), function(tag) {
    return _c('div', {
      key: tag.name,
      staticClass: "channel",
      class: {
        selected: _vm.selectedTopic === tag.topic
      },
      on: {
        "click": function($event) {
          return _vm.handleSelectTopic(tag.topic)
        }
      }
    }, [_c('div', {
      staticClass: "type"
    }, [_vm._v("#")]), _vm._v(" "), _c('span', {
      staticClass: "room",
      class: {
        unread: tag.count > 0
      }
    }, [_vm._v(_vm._s(tag.name))])])
  }), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return _c('div', {
      key: user.id,
      staticClass: "channel",
      class: {
        selected: _vm.selectedTopic === user.topic,
          present: _vm.presentUserIds.includes(user.id),
          unpresent: !_vm.presentUserIds.includes(user.id),
      },
      on: {
        "click": function($event) {
          return _vm.handleSelectTopic(user.topic)
        }
      }
    }, [_c('div', {
      staticClass: "type"
    }, [_vm._v("@")]), _vm._v(" "), _c('span', {
      staticClass: "room",
      class: {
        unread: user.count > 0
      }
    }, [_vm._v("\n      " + _vm._s(user.first_name) + " " + _vm._s(user.last_name) + "\n    ")])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4000cccd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/chat/ChannelSelector.vue
// module id = 3243
// module chunks = 3